import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import endpoints from "../../config/endpoints";
import { Sidebar } from "../../layouts/Sidebar";
import { setLoading } from "../../services/reducers/homeSlice";
import restApi from "../../services/restApi";
import RichTextEditor, {
  EDITOR_UPLOAD_PENDING_MESSAGE,
  editorUploadsPending,
} from "../../components/RichTextEditor";
import tools from "../../utils/tools";
import brand from "./index";

const BrandManage = () => {
  const { id: paramId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form, setForm] = useState<any>({});
  const [image, setImage] = useState<any>({});
  const [brands, setBrands] = useState([]);

  const send = async () => {
    // an editor image still uploading would be saved without its address
    if (editorUploadsPending()) {
      Swal.fire({
        title: "صبر کنید",
        text: EDITOR_UPLOAD_PENDING_MESSAGE,
        icon: "warning",
        confirmButtonText: "متوجه شدم",
      });
      return;
    }
    dispatch(setLoading(true));

    const brandResult = await restApi(
      endpoints.brand.basic + (paramId || ""),
    ).post(tools.extractor(form, ["title", "description", "parentId", "slug"]));
    if (brandResult.code == 200) {
      if (image.data) {
        const formData = new FormData();

        formData.append("file", image.data);

        const res = await restApi(
          endpoints.brand.medias + brandResult.data.id,
          true,
        ).upload(formData);
      }
      Swal.fire({
        title: "موفق",
        text: `برند با موفقیت ${paramId ? "ویرایش" : "ایجاد"} شد`,
        icon: "success",
        confirmButtonText: "متوجه شدم",
        didClose() {
          navigate("/brand");
        },
      });
    } else if (brandResult.code == 2001) {
      Swal.fire({
        title: "ناموفق",
        text: "URL تکراری میباشد",
        icon: "error",
        confirmButtonText: "متوجه شدم",
      });
    } else {
      Swal.fire({
        title: "ناموفق",
        text: brandResult?.data,
        icon: "error",
        confirmButtonText: "متوجه شدم",
      });
    }
    dispatch(setLoading(false));
  };

  const fetchItem = async () => {
    dispatch(setLoading(true));

    if (paramId) {
      const res = await restApi(endpoints.brand.single + paramId, true).get();

      if (res.code == 200) {
        setForm({
          title: res.data?.title,
          description: res.data?.description,
          parentId: res.data?.parentId,
          slug: res.data?.slug,
        });
        setImage({
          data: undefined,
          preview: res.data.media?.url,
        });
      }
    }
    const brandsRes = await restApi(endpoints.brand.index).get();

    if (brandsRes.code == 200) {
      setBrands(brandsRes.data);
    }

    dispatch(setLoading(false));
  };

  useEffect(() => {
    fetchItem();
  }, []);

  return (
    <>
      <body className="dashboardBody">
        <Sidebar />
        <main className="dashBoardMain main">
          <div className="addInfoHeader">
            <span
              className="dashboardHeader keepRight clickable"
              onClick={send}
            >
              {paramId ? "ویرایش " : "ایجاد "}برند
            </span>
            <span>
              <h1 className="sideBarTitle">بازگشت به صفحه برند</h1>
              <h1 className="dashBoardTitle">
                {paramId ? "ویرایش" : "ایجاد"} برند{" "}
              </h1>
            </span>
            <i
              className="backAdd clickable"
              onClick={() => navigate("/brand/")}
            ></i>
          </div>
          <section className="bottomSection">
            <h1 className="dashBoardTitle">اطلاعات برند</h1>
            <form className="addInfo">
              <label className="sideBarTitle" htmlFor="infoTitle">
                عنوان
              </label>
              <input
                className="addInput"
                id="infoTitle"
                onChange={(input: any) =>
                  setForm((prev) => ({
                    ...prev,
                    title: input.target.value,
                  }))
                }
                value={form.title}
              />
              <label>URL</label>
              <div className="rowReverse">
                <input
                  className="persianName halfWidth"
                  value={form.slug}
                  onChange={(input) =>
                    setForm((prev) => ({ ...prev, slug: input.target.value }))
                  }
                />
                <label>
                  <a
                    href={`${process.env.REACT_APP_CLIENT_URL}/brand/${form.slug}`}
                    target="_blank"
                  >{`${process.env.REACT_APP_CLIENT_URL}/brand/`}</a>
                </label>
              </div>
              <label className="sideBarTitle" htmlFor="infoTitle">
                والد
              </label>
              <Select
                options={tools.selectFormatter(
                  brands,
                  "id",
                  "title",
                  "انتخاب کنید",
                )}
                value={tools.selectFormatter(
                  brands.filter((e) => e.id == form.parentId),
                  "id",
                  "title",
                )}
                className="width100"
                onChange={(selected) =>
                  setForm((prev) => ({
                    ...prev,
                    parentId: selected.value.toString(),
                  }))
                }
              />
              <label className="sideBarTitle" htmlFor="infoAmount">
                توضیحات
              </label>
              <RichTextEditor
                value={form.description}
                onChange={(description) =>
                  setForm((prev) => ({ ...prev, description }))
                }
              />
              <input
                type="file"
                onChange={(input) =>
                  setImage({
                    data: input.target.files[0],
                    preview: URL.createObjectURL(input.target.files[0]),
                  })
                }
              />
            </form>
            <img src={image.preview} alt="لوگو" />
          </section>
        </main>
      </body>
    </>
  );
};
export default BrandManage;
